import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=9cf1d5a6&scoped=true&"
import script from "./GetStarted.vue?vue&type=script&lang=ts&"
export * from "./GetStarted.vue?vue&type=script&lang=ts&"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=9cf1d5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf1d5a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9cf1d5a6', component.options)
    } else {
      api.reload('9cf1d5a6', component.options)
    }
    module.hot.accept("./GetStarted.vue?vue&type=template&id=9cf1d5a6&scoped=true&", function () {
      api.rerender('9cf1d5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/components/landing/GetStarted.vue"
export default component.exports